import { useMutation } from '@tanstack/react-query';
import { BillingClient } from 'network/httpClients/BillingClient/BillingClient';
import { MUTATION_KEYS } from 'network/mutations/consts';

/**
 * Self-serve conversion checkout (PLT-3715).
 *
 * Calls POST /billing/v1/checkout/session with the selected `planSku` and
 * resolves to `{ sessionId, url }` — the caller redirects the browser to `url`
 * (the Stripe-hosted Checkout page). Distinct from the legacy teams checkout
 * (`useCreateCheckoutSessionMutation`, which hits /teams/create-checkout-session).
 */
export const useCreateCheckoutSession = () =>
  useMutation({
    mutationKey: [MUTATION_KEYS.CREATE_BILLING_CHECKOUT_SESSION],
    mutationFn: (planSku: string) =>
      BillingClient.createCheckoutSession({ planSku }),
  });
